import type { CSSProperties } from "react";

interface ImageProps {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  fill?: boolean;
  priority?: boolean;
  className?: string;
  style?: CSSProperties;
}

// Drop-in replacement for `next/image`. `fill` maps to an absolutely
// positioned image that covers its (positioned) parent; `priority` is a no-op.
export default function Image({
  src,
  alt,
  width,
  height,
  fill,
  priority: _priority,
  className,
  style,
}: ImageProps) {
  if (fill) {
    return (
      <img
        src={src}
        alt={alt}
        className={["absolute inset-0 h-full w-full", className].filter(Boolean).join(" ")}
        style={style}
      />
    );
  }

  return (
    <img src={src} alt={alt} width={width} height={height} className={className} style={style} />
  );
}
